(function () {
	'use strict';

    // Ensure $ is assigned to jQuery
    var $ = jQuery || window.jQuery;

    // Check if $ is available
    if ($) {
		$('[data-filter-items]').each(function () {
			var form = $(this);
			var selects = form.find('select');
			var q = form.find('[name="q"]');
			var items = $(form.attr('data-filter-items'));

			selects.on('change', function () {
				form.submit();
			});

			q.on('input', function () {
				form.submit();
			});

			form.on('submit', function (e) {
				e.preventDefault();

				// Show all items by default
				items.removeClass('filter-items--hidden');

				items.each(function () {
					$(this).closest('[data-filter-items-group]').removeClass('filter-items--all-hidden');
				});

				// Store all <select>-element values
				var classes = [];

				selects.each(function () {
					var select = $(this);

					if (select.val()) {
						classes.push('.' + select.attr('name') + '-' + select.val());
					}
				});

				// If we have either <select> values or a search string
				if (classes.length || q.val()) {
					// Hide all items
					items.addClass('filter-items--hidden');

					items.each(function () {
						$(this).closest('[data-filter-items-group]').addClass('filter-items--all-hidden');
					});

					// Now check every item for...
					items.filter(function (i, el) {
						var item = $(el);
						var isClassMatch = false;
						var isQMatch = false;

						// A class match (.select_name-value)
						if (classes.length) {
							isClassMatch = item.is(classes.join('')); // Change to ',' for an OR match
						}
						// No <select> values, anything matches
						else {
							isClassMatch = true;
						}

						// A search string match
						if (q.val()) {
							var regexp = new RegExp(q.val(), 'im');

							isQMatch = regexp.test(item.html());
						}
						// No search string, anything matches
						else {
							isQMatch = true;
						}

						// Needs to match both class and search string to be valid
						return isClassMatch && isQMatch; // Change to || for an OR match
					}).removeClass('filter-items--hidden').closest('[data-filter-items-group]').removeClass('filter-items--all-hidden');
				}
			});
		});

	};
})();
